import { OnboardingTour } from "./OnboardingTour";
import { chatSteps, chatVersion } from "./chatSteps";

interface Props {
  replayNonce?: number;
  onClose?: () => void;
}

export function ChatOnboardingTour({ replayNonce = 0, onClose }: Props) {
  return (
    <OnboardingTour
      steps={chatSteps}
      flagKey="chat"
      version={chatVersion}
      replayNonce={replayNonce}
      onClose={onClose}
    />
  );
}
